/**
 * Module summary:
 * This page shows contact details and a simple contact form. The current form
 * is a front-end placeholder that simulates submission by switching to a
 * success state after the user submits.
 */

import React, { useState } from 'react';
import AppShell from '../layout/AppShell';
import './pages.css';

const contactItems = [
  // Store the contact facts in one list so the summary cards can render from shared data.
  { label: 'Email', value: 'info@machagroup.com' },
  { label: 'Phone', value: '(555) 123-4567' },
  { label: 'Office', value: 'United States' },
  { label: 'Business Hours', value: 'Mon - Fri, 9am - 5pm' },
];

export const ContactUs: React.FC = () => {
  const [submitted, setSubmitted] = useState(false);

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Flip into the success state to simulate a completed message submission.
    setSubmitted(true);
  };

  return (
    <AppShell title="Contact Us" isDashboard>
      <div className="content-page">
        <section className="content-page__hero content-page__hero--dark contact-hero">
          <div className="content-page__hero-copy">
            <p className="content-page__eyebrow">Contact</p>
            <h1 className="content-page__title contact-hero__title">
              <img src="/Transparent-Logo.png" alt="" className="contact-hero__title-logo" aria-hidden />
              <span>Get in touch with The Macha Group.</span>
            </h1>
            <p className="content-page__subtitle">
              Have a question about assessments, reporting, or implementation? Send a message and we will follow up.
            </p>
          </div>
          <div className="contact-hero__logo-wrap" aria-hidden>
            <img src="/Transparent-Logo.png" alt="" className="contact-hero__logo" />
          </div>
        </section>

        <section className="contact-page__grid">
          {contactItems.map((item) => (
            <article key={item.label} className="content-card contact-card">
              <p className="contact-card__label">{item.label}</p>
              <p className="contact-card__value">{item.value}</p>
            </article>
          ))}
        </section>

        <section className="content-card contact-form-card">
          {submitted ? (
            <div className="contact-success">
              <p className="content-card__eyebrow">Message Sent</p>
              <h2 className="content-card__title">We received your message.</h2>
              <p className="content-card__copy">We will get back to you within 1-2 business days.</p>
              <button type="button" className="dashboard-btn dashboard-btn--solid" onClick={() => setSubmitted(false)}>
                Send Another Message
              </button>
            </div>
          ) : (
            <>
              <div className="content-card__header">
                <div>
                  <p className="content-card__eyebrow">Contact Form</p>
                  <h2 className="content-card__title">Send us a message</h2>
                </div>
              </div>

              <form onSubmit={onSubmit} className="contact-form">
                <div className="contact-form__grid">
                  <label className="contact-field">
                    <span>Full Name</span>
                    <input type="text" required />
                  </label>
                  <label className="contact-field">
                    <span>Email</span>
                    <input type="email" required />
                  </label>
                </div>

                <label className="contact-field">
                  <span>Subject</span>
                  <select required defaultValue="">
                    <option value="" disabled>Select a topic</option>
                    <option value="general">General Inquiry</option>
                    <option value="assessment">Assessment Services</option>
                    <option value="reports">Reports & Findings</option>
                  </select>
                </label>

                <label className="contact-field">
                  <span>Message</span>
                  <textarea required rows={6} />
                </label>

                <button type="submit" className="dashboard-btn dashboard-btn--solid contact-form__submit">
                  Send Message
                </button>
              </form>
            </>
          )}
        </section>
      </div>
    </AppShell>
  );
};

export default ContactUs;
